/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import {
  AI_CHATBOTS,
  CONVERSATIONS_DASHBOARD,
  SEMANTIC_AUDITOR,
  SEMANTIC_AUDITOR_TEST_BUILDER,
  VIEW_AI_CHATBOT,
  VIEW_AI_CHATBOT_CONTEXT,
} from './Screens.constants';

/**
 * All navigation items that make up Conversations screens.
 */
export const DXP_MENU_CONVERSATIONS_SCREENS: Array<NavigationItem> = [
  CONVERSATIONS_DASHBOARD,
  AI_CHATBOTS,
  VIEW_AI_CHATBOT,
  VIEW_AI_CHATBOT_CONTEXT,
  SEMANTIC_AUDITOR,
  SEMANTIC_AUDITOR_TEST_BUILDER,
];
